// FEATURE CLEANUP: editor_comment Remove "V2" from these keys
export const actionTypePrefix = '@@CommentEditorV2';
export const reduxKey = '@@CommentEditorV2';

//# sourceMappingURL=constants.js.map